import {
  ModalContent,
  //SectionContainer as Section,
} from 'src/components/Layouts';
import {
  ModalFooter,
  OriSelect,
  Input,
  TextArea,
  Form,
} from 'src/components/Antd';
import React from 'react';
import css from './css.module.less';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
// import DOMPurify from 'dompurify';
// import { get } from 'lodash';

const ScriptEdit = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { onCancel, data, onConfirm } = props;
  const [editForm] = Form.useForm();
  React.useEffect(() => {
    editForm.setFieldsValue(data);
  }, []);

  const handleOnConfirm = () => {
    editForm.validateFields().then((value) => {
      if (onConfirm) {
        onConfirm({ ...(data || {}), ...value });
      }
    });
  };
  return (
    <React.Fragment>
      <ModalContent style={{ padding: '0 24px' }}>
        <Form form={editForm}>
          <ItemWrapper
            title={getI18n('salesChannelDigitalMarketing.index.scriptName')}>
            <Form.Item
              name={'scriptName'}
              rules={[
                {
                  required: true,
                  message: getI18n('general.antd.DatePicker.item_help'),
                },
              ]}>
              <Input size={'large'} />
            </Form.Item>
          </ItemWrapper>
          <ItemWrapper
            title={getI18n(
              'salesChannelDigitalMarketing.index.scriptPosition',
            )}>
            <Form.Item name={'scriptPosition'} initialValue={'Head'}>
              <OriSelect size={'large'}>
                <OriSelect.Option value='Head'>Head</OriSelect.Option>
                <OriSelect.Option value='Body'>Body</OriSelect.Option>
              </OriSelect>
            </Form.Item>
          </ItemWrapper>
          <ItemWrapper
            title={getI18n('salesChannelDigitalMarketing.index.scriptBody')}>
            <Form.Item
              name={'scriptBody'}
              rules={[
                {
                  required: true,
                  message: getI18n('general.antd.DatePicker.item_help'),
                },
                {
                  // validateTrigger: 'onSubmit',
                  validator: async (rules: any, value: any) => {
                    const regex = /\b(alert|eval|document\.write|Function)\b/g;
                    if (regex.test(value)) {
                      return Promise.reject(
                        new Error(
                          getI18n(
                            'salesChannelDigitalMarketing.index.functionAllowed',
                          ),
                        ),
                      );
                    }
                  },
                },
                {
                  // validateTrigger: 'onSubmit',
                  validator: async (rules: any, value: any) => {
                    const validTagsRegex =
                      /^\s*(<script[\s\S]*?<\/script>\s*|<style[\s\S]*?<\/style>\s*)+$/gi;

                    if (!validTagsRegex.test(value)) {
                      return Promise.reject(
                        new Error(
                          getI18n(
                            'salesChannelDigitalMarketing.index.tagAllowed',
                          ),
                        ),
                      );
                    }
                  },
                },
              ]}>
              <TextArea />
            </Form.Item>
          </ItemWrapper>
          <div className={css.subtitle}>
            {getI18n('salesChannelDigitalMarketing.index.scriptdes')}
          </div>
        </Form>
      </ModalContent>
      <ModalFooter onCancel={onCancel} onOk={handleOnConfirm} />
    </React.Fragment>
  );
};
export default ScriptEdit;
